export const Capitalize = (text = ' ') => {
    text = text.replace('_', ' ');
    return text ? text[0].toUpperCase().concat(text.slice(1).toLowerCase()) : text;
};